// Stable pseudo-live "playing now" count so cards feel hot without a backend.
// Deterministic per offer id so counts don't jump on re-render.
export const getPlayingNow = (offer, index) => {
  const idStr = String(offer?.id ?? offer?.title ?? index);
  let h = 0;
  for (let i = 0; i < idStr.length; i++) {
    h = ((h * 31) + idStr.charCodeAt(i)) >>> 0;
  }
  const base = Math.max(220, 2400 - index * 160);
  return base + (h % 420);
};
